/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { getFromLocalStorage } from '../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../components/helper/axiosHelper';
import OTPVerifyModal from './OTPVerifyModal';

const UserPersonalnfo = ({ tab, isSecurityEditing, setIsSecurityEditing }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [epUserID, setEpUserID] = useState(null);
  const [isload, setIsload] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [otpModal, setOtpModal] = useState(false);
  const [isEmail, setIsEmail] = useState(false);

  const [updatedData, setUpdatedData] = useState({
    email: '',
    mobile: '',
  });

  const { t } = useTranslation();
  const token = localStorage.getItem('token');

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (epUserID !== null) {
      getUserData();
    }
  }, [epUserID]);

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  // Handle Data
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getUserData = async () => {
    setIsload(true);
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID }, axiosConfig)
      .then((response) => {
        const result = response?.data[0];
        setIsload(false);
        setApiData(result);
        setUpdatedData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleUpdateValue = async (type) => {
    setIsSecurityEditing(false);

    if (type === 'email') {
      setIsEmail(true);
      const body = {
        otp: 0,
        isEmail: true,
        email: updatedData.email,
        mobile: '',
        EPUserID: epUserID,
      };
      await postAsync('EP_UserAuthentication/OTPgenerator/', body, axiosConfig)
        .then((response) => {
          setOtpModal(true);
        })
        .catch((error) => {
          toast.error(`${t(error.response.data.message)}`);
        });
      // }
    } else {
      const body = {
        otp: 0,
        isEmail: isEmail,
        email: '',
        mobile: updatedData.mobile,
        EPUserID: epUserID,

      };

      await postAsync('EP_UserAuthentication/OTPgenerator/', body, axiosConfig)
        .then((response) => {
          setOtpModal(true);
        })
        .catch((error) => {
          toast.error(`${t(error.response.data.message)}`);
        });
    }
  };

  return isload ? (
    <div className="flex justify-center">
      <Loader />
    </div>
  ) : (
    <div className="w-full gap-3 flex flex-col sm:flex-row">
      {/* Email */}
      <div className="w-full sm:w-1/2">
        <label className="block  text-customgreen">
          {t('email')}
          <span className="errmsg">*</span>
        </label>
        <div className="relative flex items-center align-middle">
          <input
            required
            id="email"
            type="text"
            className="w-full mt-1 p-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
            placeholder={t('email')}
            name="email"
            value={updatedData?.email}
            onChange={handleChange}
            disabled={!isSecurityEditing}
          />
          <button
            type="submit"
            className={`w-20  text-white mt-1 h-8 py-2 ${isSecurityEditing ? 'bg-customgreen ' : 'bg-green-200'} absolute ${isActive ? 'left-2' : 'right-2'} text-xs font-semibold flex text-center justify-center rounded-md hover:text-customgreen transition-all duration-200 ease-in-out`}
            onClick={() => handleUpdateValue('email')}
            disabled={!isSecurityEditing}
          >
            {t('Update')}
          </button>
        </div>
      </div>

      {/* Mobile Number */}
      <div className="w-full sm:w-1/2">
        <label className="block text-customgreen">
          {t('Mobile')}
          <span className="errmsg">*</span>
        </label>
        <div className="relative flex items-center">
          <input
            required
            id="mobile"
            type="text"
            className="w-full mt-1 px-2 border rounded-md text-gray-600 focus:ring-2 focus:ring-customgreen"
            placeholder={t('Mobile')}
            name="mobile"
            value={updatedData.mobile}
            disabled={!isSecurityEditing}
            onInput={(event) => {
              const { value } = event.target;
              if (/^\+?\d*$/.test(value)) {
                setUpdatedData((prevState) => ({
                  ...prevState,
                  mobile: value,
                }));
              } else {
                event.target.value = '';
                setUpdatedData((prevState) => ({
                  ...prevState,
                  mobile: '',
                }));
              }
            }}
          />
          <button
            type="submit"
            className={`w-20  ${isSecurityEditing ? 'bg-customgreen ' : 'bg-green-200'} text-white mt-1 h-8 py-2 absolute ${isActive ? 'left-2' : 'right-2'} text-xs font-semibold flex text-center justify-center rounded-md hover:text-customgreen transition-all duration-200 ease-in-out`}
            onClick={() => handleUpdateValue('number')}
            disabled={!isSecurityEditing}
          >
            {t('Update')}
          </button>
        </div>
      </div>

      <OTPVerifyModal
        otpModal={otpModal}
        setOtpModal={setOtpModal}
        prevData={apiData}
        isEmail={isEmail}
        userId={epUserID}
        updatedData={updatedData}
        setUpdatedData={setUpdatedData}
      />
    </div>
  );
};

export default UserPersonalnfo;
